import React from "react";

import Form from "antd/es/form";
import { useIntl } from "react-intl";

import { TextField } from "@mapmycustomers/ui";

import CurrencySelect from "@app/component/CurrencySelect";
import DistanceUnitSelect from "@app/component/DistanceUnitSelect";
import TimeZoneSelect from "@app/component/TimeZoneSelect";

import styles from "./MainFields.module.scss";

interface Props {}

const MainFields: React.FC<Props> = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <Form.Item name="name">
        <TextField
          label={intl.formatMessage({
            id: "settings.organizationDetails.name",
            defaultMessage: "Organization Name",
            description: "Title of settings organization name",
          })}
        />
      </Form.Item>
      <Form.Item name="timezone">
        <TimeZoneSelect
          label={intl.formatMessage({
            id: "settings.organizationDetails.utcOffset",
            defaultMessage: "Organization Timezone",
            description: "Title of settings organization timezone",
          })}
        />
      </Form.Item>
      <Form.Item name="currency">
        <CurrencySelect
          label={intl.formatMessage({
            id: "settings.organizationDetails.currency",
            defaultMessage: "Organization Currency",
            description: "Title of settings organization currency",
          })}
        />
      </Form.Item>
      <Form.Item name="distance">
        <DistanceUnitSelect
          label={intl.formatMessage({
            id: "settings.organizationDetails.distance",
            defaultMessage: "Show distances in",
            description: "Title of settings organization distance unit",
          })}
        />
      </Form.Item>
    </div>
  );
};

export default MainFields;
